// ESM entry. Re-exports the CommonJS implementation through a default import,
// which works both in Node's ESM loader and in webpack's strict .mjs mode
// (named imports from CommonJS are not allowed there).
import rules from './index.js';

export const {
  CURRENT_PIPELINE_VERSION,
  DEFAULT_TIME_ZONE,
  isCurrentPipeline,
  getSessionPipelineVersion,
  isCurrentPipelineSession,
  hasJudgeConfidence,
  isScoredSession,
  getResolutionStatus,
  getSessionPriority,
  toPeriodKey,
  countUserMessagesByMessageDate,
  BUCKET_NO_WIDGET,
  bucketKey
} = rules;

export default rules;
